/* Three Oh Six — Newsletter-Gate (3.10.2026)
   Gemeinsame Regeln fuer beide Newsletter-Popups (assets/timed-popup.js und
   assets/exit-intent.js). Eingebunden aus sections/timed-popup.liquid und
   sections/exit-intent.liquid, jeweils VOR dem Popup-Skript (defer, laeuft in
   Dokument-Reihenfolge). Doppelt eingebunden ist harmlos: der zweite Lauf
   bricht sofort ab. Die Liquid-Seite liefert snippets/newsletter-gate.liquid.

   HART, blockedReason(root): fuer diese Person bzw. auf dieser Seite nie ein Popup
   - 'customer'   eingeloggte Kundin (data-nl-customer="logged-in" am Popup-Root)
   - 'page'       Warenkorb, Password-Page, /policies/*, Rechtsseiten und
                  Advertorial-Seiten (data-nl-excluded="true", dazu als Rueckfall
                  die Pfad-Pruefung und ein Advertorial-Root .adv-ck / .adv-ed
                  im DOM, seit 8.10.2026)
   - 'subscribed' Anmelde-Flag localStorage tos_exit_captured = '1'. Gesetzt
                  von JEDEM erfolgreichen Klaviyo-Signup im Theme (fetch auf
                  a.klaviyo.com/client/subscriptions mit 2xx, egal ob Popup,
                  Footer, Signup-Karte oder Coming Soon), von Links aus
                  Klaviyo-Mails (_kx= / utm_source=klaviyo / utm_medium=email)
                  und von nativen Shopify-Newsletter-Formularen (customer_posted=true).
   - 'recent'     in den letzten 30 Minuten hat schon ein Newsletter-Popup
                  geoeffnet, auch in einem anderen Tab (Zeitstempel der beiden
                  Frequency-Caps). Pro Tab gilt zusaetzlich der Session-Guard.
   blockedReason(root, { allowKnown: true }) laesst 'customer' und 'subscribed'
   weg (nur Seite + 30-Minuten-Fenster): fuer die Warenkorb-Erinnerung des
   Exit-Intent, die Angemeldete und Eingeloggte weiter sehen (Kathrin, 7.10.2026).
   knownReason(root) liefert 'customer' / 'subscribed' / '' einzeln.
   WEICH, busyReason(): gerade nicht, spaeter erneut versuchen
   - 'cookie-banner' Pandectes-Banner offen (dialog im Shadow Root von pandectes-cmp)
   - 'overlay'    Warenkorb-Drawer, Quick View, Groessentabelle, Menue oder ein
                  anderes Modal/Drawer ist sichtbar offen
   - 'typing'     Fokus in einem Texteingabefeld */
(function () {
  if (window.TOSNewsletterGate) return;

  var LS_DONE = 'tos_exit_captured';
  var LS_CAPS = ['tos_timed_last_shown', 'tos_exit_last_shown'];
  var SAME_VISIT_MS = 30 * 60 * 1000;
  var LEGAL_PATH = /^\/pages\/(terms-and-conditions|right-of-withdrawal|privacy-policy|legal-notice)\/?$/;
  var KLAVIYO_SUBSCRIBE = /^https:\/\/a\.klaviyo\.com\/client\/subscriptions\/?(?:\?|$)/;
  // Body-Klassen, die das Theme bei offenen Fenstern setzt (ModalComponent,
  // Shop the Look, Size-Warning, Suche, Mobil-Menue, Announcement-Sheet).
  var BODY_BUSY = ['modal-show', 'modal-showing', 'stl-open', 'size-warning-modal-open', 'predictive-search-open', 'mobile-menu-is-open', 'overflow-hidden'];
  var OVERLAY_SEL = '[open]:not(details), [aria-modal="true"], [role="dialog"], .drawer.active, .drawer.opened, .complete-set-drawer.active';

  function lsGet(k) {
    try { return window.localStorage.getItem(k); } catch (e) { return null; }
  }
  function lsSet(k, v) {
    try { window.localStorage.setItem(k, v); } catch (e) {}
  }

  function markSubscribed() { lsSet(LS_DONE, '1'); }
  function isSubscribed() { return lsGet(LS_DONE) === '1'; }

  // --- Anmelde-Flag aus der URL (Klaviyo-Mail, natives Shopify-Formular) ---
  try {
    var q = String(window.location.search || '').toLowerCase();
    if (/[?&]_kx=/.test(q) || /[?&]utm_source=klaviyo/.test(q) || /[?&]utm_medium=email/.test(q) || /[?&]customer_posted=true/.test(q)) {
      markSubscribed();
    }
  } catch (e) {}

  // --- Anmelde-Flag aus jedem erfolgreichen Klaviyo-Signup im Theme ---
  // Nur beobachten: der Aufrufer bekommt exakt das Original-Promise zurueck.
  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var p = nativeFetch.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
        if (KLAVIYO_SUBSCRIBE.test(url) && p && typeof p.then === 'function') {
          p.then(function (res) { if (res && res.ok) markSubscribed(); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  // --- Harte Gates ---
  function pathExcluded() {
    var p = String(window.location.pathname || '/').toLowerCase();
    p = p.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/, '') || '/';
    if (p === '/cart' || p === '/cart/' || p === '/password') return true;
    if (p.indexOf('/policies/') === 0) return true;
    return LEGAL_PATH.test(p);
  }

  // Advertorial-Landingpages (kalter Meta-Traffic): Rueckfall ueber das
  // Root-Element, falls das HTML data-nl-excluded noch nicht traegt.
  function advertorialPage() {
    return !!document.querySelector('.adv-ck, .adv-ed');
  }

  function recentlyShown() {
    var now = Date.now();
    for (var i = 0; i < LS_CAPS.length; i++) {
      var t = parseInt(lsGet(LS_CAPS[i]) || '0', 10);
      if (t && now - t >= 0 && now - t < SAME_VISIT_MS) return true;
    }
    return false;
  }

  function isCustomer(root) {
    return !!root && root.getAttribute('data-nl-customer') === 'logged-in';
  }

  function knownReason(root) {
    if (isCustomer(root)) return 'customer';
    if (isSubscribed()) return 'subscribed';
    return '';
  }

  function blockedReason(root, opts) {
    var allowKnown = !!(opts && opts.allowKnown);
    if (!allowKnown && isCustomer(root)) return 'customer';
    if ((root && root.getAttribute('data-nl-excluded') === 'true') || pathExcluded() || advertorialPage()) return 'page';
    if (!allowKnown && isSubscribed()) return 'subscribed';
    if (recentlyShown()) return 'recent';
    return '';
  }

  // --- Weiche Gates ---
  function shown(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    if (r.bottom <= 0 || r.right <= 0 || r.top >= window.innerHeight || r.left >= window.innerWidth) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var own = window.getComputedStyle(el);
    if (own.visibility === 'hidden') return false;
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var cs = n === el ? own : window.getComputedStyle(n);
      if (cs.display === 'none' || parseFloat(cs.opacity) < 0.05) return false;
    }
    return true;
  }

  function hasConsentDecision() {
    return /(?:^|;\s*)_pandectes_gdpr=/.test(document.cookie || '');
  }

  function cookieBannerOpen() {
    var host = document.querySelector('pandectes-cmp');
    if (!host) return false;
    var sr = host.shadowRoot;
    if (!sr) return !hasConsentDecision();
    var dialogs = sr.querySelectorAll('dialog[open], .dialog');
    for (var i = 0; i < dialogs.length; i++) {
      if (shown(dialogs[i])) return true;
    }
    return false;
  }

  function overlayOpen() {
    var b = document.body;
    if (b) {
      for (var i = 0; i < BODY_BUSY.length; i++) {
        if (b.classList.contains(BODY_BUSY[i])) return true;
      }
    }
    var els = document.querySelectorAll(OVERLAY_SEL);
    for (var j = 0; j < els.length; j++) {
      if (els[j].closest('.tos-exit')) continue; // die Popups selbst
      if (shown(els[j])) return true;
    }
    return false;
  }

  function typing() {
    var a = document.activeElement;
    if (!a || a === document.body || a === document.documentElement) return false;
    if (a.closest && a.closest('.tos-exit')) return false;
    if (a.isContentEditable || a.tagName === 'TEXTAREA') return true;
    if (a.tagName !== 'INPUT') return false;
    return !/^(button|submit|reset|checkbox|radio|range|color|file|image|hidden)$/i.test(a.type || '');
  }

  function busyReason() {
    if (cookieBannerOpen()) return 'cookie-banner';
    if (overlayOpen()) return 'overlay';
    if (typing()) return 'typing';
    return '';
  }

  window.TOSNewsletterGate = {
    blockedReason: blockedReason,
    knownReason: knownReason,
    busyReason: busyReason,
    markSubscribed: markSubscribed,
    isSubscribed: isSubscribed
  };
})();
